import React, { useState } from "react";

import HideIcon from "@src/assets/icons/hide.svg";
import ShowIcon from "@src/assets/icons/show.svg";
import { Project } from "@src/types";
import { Button, Collapse, CollapseProps, Tooltip } from "antd";

import { ProjectDetails } from "../project_details";
import { ResourcePlanDashboard } from "../resource_plan_dashboard";
import { ResourcePlanTable } from "../resource_plan_table";

import "./resource_plan_overview_tab.less";

interface ResourcePlanOverviewTabProps {
  project: Project;
  isLoading: boolean;
}

const ResourcePlanOverviewTab: React.FC<ResourcePlanOverviewTabProps> = ({
  project,
  isLoading,
}) => {
  const [showDashboard, setShowDashboard] = useState<boolean>(true);

  const items: CollapseProps["items"] = [
    {
      key: "1",
      children: <ResourcePlanDashboard projectId={project?.id} />,
      showArrow: false,
    },
  ];

  function onShowDashboard() {
    setShowDashboard(!showDashboard);
  }

  return (
    <div className="resource-plan-overview-tab">
      <div className="resource-plan-overview-tab__project-details">
        <ProjectDetails project={project} isLoading={isLoading} />

        <Tooltip
          placement="top"
          title={`${showDashboard ? "Hide" : "Show"} Dashboard`}
        >
          <Button
            data-testid={showDashboard ? "hide-button" : "show-button"}
            size="large"
            color="primary"
            variant="filled"
            icon={
              showDashboard ? (
                <HideIcon data-testid="hide-icon" />
              ) : (
                <ShowIcon data-testid="show-icon" />
              )
            }
            onClick={() => onShowDashboard()}
          />
        </Tooltip>
      </div>

      <Collapse
        className="resource-plan-overview-tab__dashboard"
        defaultActiveKey={"1"}
        activeKey={showDashboard ? ["1"] : []}
        ghost
        items={items}
        collapsible={"disabled"}
        accordion
      />

      {project && (
        <ResourcePlanTable
          projectId={project.id.toString()}
          projectEndDate={project?.endDate}
        />
      )}
    </div>
  );
};

export default ResourcePlanOverviewTab;
